// 使用条件导入
let TRTCLiveService;

if (process.env.VUE_APP_ELECTRON) {
  // Electron environment
  TRTCLiveService = require("./electron-trtc").default;
} else {
  // Web environment
  TRTCLiveService = require("./web-trtc").default;
}

export default TRTCLiveService;
